// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rosters {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.rosterHome, .rosterRoad {
  margin-top: 50px;
  display: flex;
  justify-self: center;
  width: 90%;
}

@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  .rosterHome, .rosterRoad {
    font-size: 10px;
    width: 90%;
  }
  .rosterHome th, .rosterHome td, .rosterRoad th, .rosterRoad td {
    font-size: 9px;
    white-space: nowrap;
    height: 10px;
  }
}
.top-players {
  margin: 50px !important;
  grid-template-columns: 1fr 1fr;
  box-shadow: 5px 5px 8px #c4c5ea;
  background-color: rgb(211, 253, 253);
  color: black;
  border-radius: 2em;
  height: 400px;
  text-align: center;
}

.top-player, .space {
  width: 1200px;
}

.points-container, .assist-container, .rebonds-container {
  display: flex;
  flex-direction: column;
}

h2 {
  margin: 10px 0 0 0;
}

th:nth-child(1) {
  border-top-left-radius: 0.5em;
}

tr:nth-last-child(1) td:nth-child(1) {
  border-bottom-left-radius: 0.5em;
  border-bottom: none;
}

th:nth-last-child(1) {
  border-top-right-radius: 0.5em !important;
}

tr:nth-last-child(1) td:nth-last-child(1) {
  border-bottom-right-radius: 0.5em;
  border-bottom: none;
}

table {
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/roster-points/roster-points.component.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,8BAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;AADF;;AAIA;EAEE,uBAAA;EACA;IACE,eAAA;IACA,UAAA;EAFF;EAGE;IACE,cAAA;IACA,mBAAA;IACA,YAAA;EADJ;AACF;AAMA;EACE,uBAAA;EACA,8BAAA;EACA,+BAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAJF;;AAOA;EACA,aAAA;AAJA;;AAOA;EACE,aAAA;EACA,sBAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EAEI,6BAAA;AALJ;;AAQA;EAEI,gCAAA;EACA,mBAAA;AANJ;;AASA;EAEI,yCAAA;AAPJ;;AAUA;EAEI,iCAAA;EACA,mBAAA;AARJ;;AAWA;EACE,mBAAA;AARF","sourcesContent":["@import \"/src/utilities/variables\";\r\n\r\n.rosters {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n}\r\n\r\n.rosterHome, .rosterRoad {\r\n  margin-top: 50px;\r\n  display: flex;\r\n  justify-self: center;\r\n  width: 90%;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\r\n  /* For mobile phones: */\r\n  .rosterHome, .rosterRoad {\r\n    font-size: 10px;\r\n    width: 90%;\r\n    th, td {\r\n      font-size: 9px;\r\n      white-space: nowrap;\r\n      height: 10px;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.top-players {\r\n  margin: 50px!important;\r\n  grid-template-columns: 1fr 1fr;\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  background-color: rgb(211, 253, 253);\r\n  color: black;\r\n  border-radius: 2em;\r\n  height: 400px;\r\n  text-align: center;\r\n}\r\n\r\n.top-player, .space {\r\nwidth: 1200px;\r\n}\r\n\r\n.points-container, .assist-container, .rebonds-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\nh2 { \r\n  margin : 10px 0 0 0 ; \r\n}\r\n\r\nth:nth-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-top-left-radius: 0.5em;\r\n}\r\n\r\ntr:nth-last-child(1) td:nth-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-bottom-left-radius: 0.5em;\r\n    border-bottom: none;\r\n}\r\n\r\nth:nth-last-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-top-right-radius: 0.5em!important;\r\n}\r\n\r\ntr:nth-last-child(1) td:nth-last-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-bottom-right-radius: 0.5em;\r\n    border-bottom: none;\r\n}\r\n\r\ntable {\r\n  border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
